import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-cycle
import { useErrorStore } from './error-store';
import * as profileRepo from '../services/profile';
import * as logger from '../utils/logger';
// eslint-disable-next-line import/no-cycle
import { useApplicationStore } from './application-store';

export const useProfile = defineStore('profile', {
    state: () => ({
        hasValidProfile: false,
        hasProfile: false,
        hasMiniProfile: false,
        hasUser: false,
        email: undefined,
        phoneNumber: undefined,
        firstname: undefined,
        lastname: undefined,
        profileImageUrl: undefined,
        completeness: undefined,
    }),
    getters: {
        profileFetched: state => state.email !== undefined,
        userTypeDetail: (state) => {
            if (!state.hasUser) {
                return null;
            }
            if (state.hasProfile) {
                return 'profile';
            }
            if (state.hasMiniProfile) {
                return 'mini-profile';
            }

            return 'account';
        },
    },
    actions: {
        setProfile(profile) {
            this.$patch({
                hasUser: true,
                email: profile.basics.contact.email,
                phoneNumber: profile.basics.contact.mobile,
                firstname: profile.basics.firstname,
                lastname: profile.basics.surname,
                completeness: profile.completeness,
            });

            // Use the "square" version of the profile image for the header bento.
            const imageType = 'square';
            this.profileImageUrl = profile.image.length > 0 ?
                profile.image.find(result => result.version === imageType).url :
                null;

            if (profile.flags.exists) {
                this.$patch({
                    hasProfile: true,
                    hasValidProfile: Boolean(profile.basics.firstname),
                });
            }

            if (profile.flags.isMiniProfile) {
                this.$patch({
                    hasMiniProfile: true,
                });
            }
        },
        async getProfile() {
            const errors = useErrorStore();
            try {
                const profile = await profileRepo.getProfile();
                this.setProfile(profile.data);

                const application = useApplicationStore();
                application.set(profile.data);
            } catch (exception) {
                logger.error({
                    exception,
                    message: 'Fetching profile failed.',
                    extra: {
                        response:
                            exception.response?.data ?
                                JSON.stringify(exception.response.data) :
                                'No response available.',
                    },
                });
                errors.general = true;
            }
        },
    },
});
